import { forwardRef } from 'react';

import { cn } from 'lib/helpers/utility';

import { CONTAINER_VARIANTS } from './lib/constants';

/** @type {React.FC<import('./lib/propTypes').ContainerProps>} */

const Container = forwardRef(
  ({ as: Tag = 'div', variant = 'container', className, children, ...rest }, ref) => (
    <Tag ref={ref} className={cn('xs:px-4', CONTAINER_VARIANTS[variant], className)} {...rest}>
      {children}
    </Tag>
  )
);

Container.displayName = 'Container';

export default Container;
